module.exports = {
  apiConfig: [{
    name: '获取图标(icon)配置',
    method: 'IconConfig',
    url: '/resource/iconfont/iconfont-acm.json',
    type: 'get'
  }]
}
